var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"seccion blog-carrousel"},[(_vm.title)?_c('h2',[_vm._v("BLOG")]):_vm._e(),_c('div',{staticClass:"columns slidex-wrap"},_vm._l((_vm.slidesComp),function(slide,$index){return _c('div',{key:`slidex-blog-${$index}`,staticClass:"column is-one-third"},[_c('card',{attrs:{"content":slide}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }